export const refTrnType = {
  TL_YUKLEME: 2,
  ABONMAN_YUKLEME: 7,
  yeniKartBasvurusu: 1,
  DIGITAL_KART_TL_YUKLEME: 6,
  DIGITAL_KART_ABONMAN_YUKLEME: 10,
  ikinciKargoBasvurusu: 11,
};
